import { useNavigate } from 'react-router-dom'
import { Avatar } from '../../cwp-components/Utils'

type PostProps = {
  data: any
  count?: any
  className?: string
  isActive?: boolean
}

export const PostCard = ({
  data,
  count,
  className,
  isActive = false,
}: PostProps) => {
  const navigate = useNavigate()
  const route = (id: string) => {
    navigate(`/articles/${id}`)
  }
  return (
    <>
      <div
        onClick={() => route(data?.id)}
        className={`card cursor-pointer !rounded-xl flex flex-col bg-[#fff] ${className} `}
      >
        {!isActive && (
          <img
            className={`${
              count % 2 ? 'order-last rounded-b-lg' : 'rounded-t-lg'
            } min-h-[120px] h-[191px]  w-full `}
            style={{
              background: `url(${data?.cover_image}) lightgray 50% / cover no-repeat`,
            }}
          />
        )}

        <div className='p-5'>
          {!isActive ? (
            <>
              <h5 className='text-[16px]'>{data.title}</h5>
              <p className='text-sm my-1'>{data.description}</p>
            </>
          ) : (
            <>
              <div className='flex flex-row items-center justify-between'>
                <h5 className='text-[16px]'>{data.title}</h5>
                <div className=' badge badge-primary mt-3 max-sm:!p-4'>
                  <Avatar
                    className={'pr-2 min-w-[124px]'}
                    picture={data?.author?.avatar}
                    caption={data?.author?.author_type}
                    name={data?.author?.name}
                  />
                </div>
              </div>

              <p className='text-sm my-1'>{data.summary}</p>
            </>
          )}

          <div className='flex gap-2 my-1'>
            {data?.tags &&
              data?.tags?.map((tag, idx) => (
                <span className='badge bg-[#EBF3FF]' key={`tags` + idx}>
                  {tag}
                </span>
              ))}
          </div>

          {!isActive && (
            <>
              <hr />
              <div className={`badge badge-primary mt-3 max-sm:!p-4 `}>
                <Avatar
                  className={'pr-2 min-w-[124px]'}
                  picture={data?.author?.avatar}
                  caption={data?.author?.author_type}
                  name={data?.author?.name}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}
